exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".navbar .material-icons.loved {\n  color: #ff5722; }\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./~/sass-loader!./client/app/components/navbar/navbar.scss
 ** module id = 18
 ** module chunks = 0
 **/